/**
 * $t('enum.E_UpkeepRepairHandleStatus.PendingAssign')
 * $t('enum.E_UpkeepRepairHandleStatus.PendingCheck')
 * $t('enum.E_UpkeepRepairHandleStatus.Resolve')
 */
export enum E_UpkeepRepairHandleStatus {
    /**
     * 待审批
     */
    PendingAssign = 1,
    /**
     * 待检测
     */
    PendingCheck = 2,
    /**
     * 已结单
     */
    Resolve = 3,
}